<div class="row {{input?.inputType}}-input" 
  [ngClass]="{'mapfre-input': input?.inputType !== 'textarea', 'rowEditMail': input?.key === 'changeAddressAPT' || 'changeAddress', 'no-margin-horizontal password-input-new':input?.key === 'createPassword', 'radio-checkboxes-row': input?.inputType === 'accountType', 'margin-bottom mb8': input?.inputType !== 'accountType'}">
  <div class="col input-content" [ngClass]="{'colEditMail': input?.key === 'changeAddressAPT' || 'changeAddress', 'no-padding ma-password-input':input?.key === 'createPassword', 'radio-checkboxes': input?.inputType === 'accountType'}">
    <div [formGroup]= "form" class= "input-field mapfre" [class.active]="enableActiveStyle && form.get(input.key)?.value">
      <div [ngSwitch]= "input?.icon" class= "prefix">
        <i [class]= "input?.iconClasses" *ngSwitchCase= "true"></i>
      </div>
      <div *ngIf="input?.inputType === 'email'">
        <input
          (blur)= "OnBlur(this)"
          (focus)= "OnFocus(this)"
          (keyup)="OnKeyUp(this)"
          [class]= "input?.additionalClasses"
          [formControlName]= "input?.key" 
          [id]= "input?.key" 
          [name]="input?.key"
          [ngClass]="{'error': !validInput || (isValid && showError && errorMessage && input?.key === 'confirmation_changeEmail')}"
          [type]= "input?.inputType"
          [placeholder]="input?.placeholder"
          autocomplete="off"
          #email 
          mdbInput
          email
         />
        <mapfre-label [forInput]= "input?.key" [validationCSSClass]="validInput" [ngClass]="{'tested': input?.key === 'loginEmail'}">{{ input?.label | translate }}</mapfre-label>
      </div>
      <div *ngIf="input?.inputType === 'textarea'">
        <textarea 
          (blur)= "OnBlur(this)"
          (focus)= "OnFocus(this)"
          (keyup)= "OnKeyUp(this)"
          [class]= "input?.additionalClasses"
          [formControlName]= "input?.key"
          [maxLength]="input?.maxLength || maximumLength"
          [id]= "input?.key"
          [name]= "input?.key"
          autocomplete="off"
          mdbInput 
          ></textarea>
        <mapfre-label [forInput]="input?.key" [validationCSSClass]="validInput">{{ input?.label | translate }}</mapfre-label>
      </div>
      <div *ngIf="input?.inputType === 'address'" class="address-input" [ngClass]="{'w-100-mobile': input?.key === 'changeAddress'}">
        <input 
          (blur)= "OnBlurStoreAddress()"
          (focus)= "OnFocus(this)"
          (keyup)= "onkeyUpCheckAddress()"
          [class]= "input?.additionalClasses"
          [formControlName]= "input?.key"
          [id]= "input?.key"
          [name]= "input?.key"
          [ngClass]="{'error': !validInput || changeAddressError }"
          type="text"
          autocomplete="off"
          mdbInput
          #autoCompleteAddress
          />
        <mapfre-label [forInput]= "input?.key" [validationCSSClass]="validInput || changeAddressError" [ngClass]="{'tested': input?.key === 'changeAddress'}">{{ input?.label | translate }}</mapfre-label>
      </div>
      <div *ngIf="input?.inputType === 'zipcode'" class="address-input">
        <input
          (blur)= "OnBlur(this)"
          (keyup)= "getAddressByZipcode(this)"
          [class]= "input?.additionalClasses"
          [formControlName]= "input?.key"
          [id]= "input?.key"
          [name]= "input?.key"
          type="text"
          [ngClass]="{'error': !validInput || showInvalidZipcodeMsg}"
          autocomplete="off"
          mdbInput
          #zipcodeRef
          />
          <mapfre-label [forInput]="input?.key" [validationCSSClass]="!showInvalidZipcodeMsg">{{ input?.label | translate }}</mapfre-label>
      </div>
      <div *ngIf="input?.inputType === 'poBoxNumber'" class="address-input">
        <input
          [class]= "input?.additionalClasses"
          [formControlName]= "input?.key"
          [id]= "input?.key"
          [name]= "input?.key"
          type="text"
          autocomplete="off"
          mdbInput
          #poBoxNumberRef
          />
          <mapfre-label [forInput]="input?.key" [validationCSSClass]="validInput">{{ input?.label | translate }}</mapfre-label>
      </div>
      <div *ngIf="input?.inputType === 'phone'">
        <input 
          (blur)= "OnBlur(this)"
          (focus)= "OnFocus(this)"
          (keyup)="OnKeyUp(this)"
          [class]= "input?.additionalClasses"
          [formControlName]= "input?.key"
          [id]= "input?.key"
          [maxLength]="input?.maxLength || maximumLength"
          [name]= "input?.key"
          type= "tel"
          [ngClass]="{'error': !validInput}"
          [ngModel]="phoneNumber | formatPhone: true" 
          (ngModelChange)="phoneNumber=$event"
          autocomplete="off"
          #phone
          appNumericInput
          mdbInput
          />
        <mapfre-label [forInput]= "input?.key" [validationCSSClass]="validInput">{{ input?.label | translate }}</mapfre-label>
      </div>
      <div *ngIf="input?.inputType === 'bank'">
        <input 
          (blur)= "OnBlur(this)"
          (focus)= "OnFocus(this)"
          (keyup)="OnKeyUp(this)"
          [class]= "input?.additionalClasses"
          [formControlName]= "input?.key"
          [maxLength]="input?.maxLength || maximumLength"
          [id]= "input?.key"
          [name]= "input?.key"
          [ngClass]="{'error': !validInput || error}"
          [maxLength]="maximumLength"
          [placeholder]="input?.placeholder"
          type= "tel"
          autocomplete="off"
          #bank
          appNumericInput
          mdbInput
          />
        <mapfre-label [forInput]= "input?.key" [validationCSSClass]="validInput" [ngClass]="{'bankEdit': input?.key?.includes('enrollInEft_')}">{{ input?.label | translate }}
          <span *ngIf="input?.key === 'enrollInEft_routingNumber'">
            <mapfre-tooltip 
              additionalClasses="dflex-align-center" 
              [placementLocation]="tooltipPos" 
              [title]="'ROUTING NUMBER'" 
              autoCloseProp="false"        
              [trigger]="'manual'"
              imgPath="assets/img/images/checking-routing-number.png"
              imageHasBody="true"
              autocomplete="off"
            >
            <!-- <img src="assets/img/images/icon-info.svg" width="14"/> -->
          </mapfre-tooltip>
          </span>
          <span *ngIf="input?.key === 'newPayment_routingNumber'" class="ctooltip tooltip-positioning bank-number-ctooltip" (mouseenter)="onTolltipHover()" [ngClass]="{'tooltip-show': isTooltipVisible}">
            <ng-container *ngIf="!isAcmic; else acmicIcon">
              <img src="assets/img/images/icon-info-red.svg" alt="info icon "  class="tooltip-icon"/>
            </ng-container>
            <ng-template #acmicIcon>
              <img src="assets/img/images/icon-info-acmic.svg" alt="info icon "  class="tooltip-icon"/>
            </ng-template>
            <app-mapfre-custom-tooltip [toolTipImage]="'assets/img/images/tooltip-routingnumber-img.png'" 
            [tooltipTitle]="'Find your routing and account number'"
            [description]="'An example of where to find the routing and account number on a check is below.'"
            (showTooltip)="showToolTip($event)"
            ></app-mapfre-custom-tooltip>
          </span>
        </mapfre-label>
      </div>
      <div *ngIf="input?.inputType === 'bank_account_number'">
        <input 
          (blur)= "OnBlur(this)"
          (focus)= "OnFocus(this)"
          (keyup)="OnKeyUp(this)"
          [class]= "input?.additionalClasses"
          [maxLength]="input?.maxLength || maximumLength"
          [formControlName]= "input?.key"
          [id]= "input?.key"
          [name]= "input?.key"
          [ngClass]="{'error': !(input?.key?.includes('enrollInEft_')) 
                        ? !validInput
                        : (form.errors?.notMatch && !isFocused) ? true : form.get(input?.key)?.errors && !isFocused && form.get(input?.key)?.touched}"
          type= "tel"
          [placeholder]="input?.placeholder"
          autocomplete="off"
          #bank_account_number
          appNumericInput
          mdbInput
          />
        <mapfre-label [forInput]= "input?.key" [validationCSSClass]="validInput" [ngClass]="{'bankEdit': input?.key?.includes('enrollInEft_')}">{{ input?.label | translate }}
          <span *ngIf="input?.key === 'enrollInEft_accountNumber'">
            <mapfre-tooltip 
              additionalClasses="dflex-align-center" 
              [placementLocation]="tooltipPos" 
              [title]="'ACCOUNT NUMBER'" 
              autoCloseProp="false"        
              [trigger]="'manual'"
              imgPath="assets/img/images/checking-account-number.png"
              imageHasBody="true"
              autocomplete="off"
            >
            <!-- <img src="assets/img/images/icon-info.svg" width="14"/> -->
          </mapfre-tooltip>
          </span>
          <span *ngIf="input?.key === 'newPayment_accountNumber'" class="ctooltip tooltip-positioning bank-number-ctooltip" (mouseenter)="onTolltipHover()" [ngClass]="{'tooltip-show': isTooltipVisible}">
            <ng-container *ngIf="!isAcmic; else acmicIcon">
              <img src="assets/img/images/icon-info-red.svg" alt="info icon "  class="tooltip-icon"/>
            </ng-container>
            <ng-template #acmicIcon>
              <img src="assets/img/images/icon-info-acmic.svg" alt="info icon "  class="tooltip-icon"/>
            </ng-template>
            <app-mapfre-custom-tooltip [toolTipImage]="'assets/img/images/tooltip-routingnumber-img.png'" 
            [tooltipTitle]="'Find your routing and account number'"
            [description]="'An example of where to find the routing and account number on a check is below.'" (showTooltip)="showToolTip($event)"></app-mapfre-custom-tooltip>
          </span>
        </mapfre-label>
      </div>
      <div *ngIf="input?.inputType === 'money'">
        <input 
          (blur)= "OnBlur(this)"
          (focus)= "OnFocus(this)"
          (keyup)="OnKeyUp(this)"
          [class]= "input?.additionalClasses"
          [formControlName]= "input?.key"
          [id]= "input?.key"
          [ngClass]="{'error': !validInput}"
          type= "tel"
          autocomplete="off"
          mdbInput
          #money
          />
        <mapfre-label [forInput]= "input?.key" [validationCSSClass]="validInput">{{ input?.label | translate }}</mapfre-label>
      </div>
      <div *ngIf="input?.inputType === 'password'">
        <input
          (blur)= "OnBlur(this)"
          (focus)= "OnFocus(this)"
          (keyup)="OnKeyUp(this)"
          [class]= "input?.additionalClasses"
          [formControlName]= "input?.key"
          [id]= "input?.key"
          [ngClass]="{'error': !validInput || (!isValid && !form.controls.changePassword?.errors?.required && input?.key === 'changePassword' )}"
          [type]= "showPassword ? 'text' : 'password'"
          autocomplete="off"
          #password
          mdbInput
         />
        <mapfre-icon 
          password= "true"
          [focusShowIcon]= "showPasswordIcon"
          [showIconsForPassword]= "input?.showPasswordIcon"
          (clickShowPassword)= "showPasswordFunction($event)">
        </mapfre-icon>
        <mapfre-label [forInput]= "input?.key" [validationCSSClass]="validInput" [ngClass]="{'tested': input?.key === 'changePassword' || input?.key === 'loginPassword'}">{{ input?.label | translate }}</mapfre-label>
      </div>
      <div *ngIf="input?.inputType === 'accountType'" class="account-type-radio-group d-flex">
        <div class="account-type-radio-option">
          <!-- <div> -->
            <input
            type="radio"
            [id]="input?.key + '-checking'"
            [name]="input?.key"
            [formControlName]="input?.key"
            value="CHECKINGL"
            (change)="OnKeyUp(this)"
          />
          <!-- </div>
          <div> -->
            <label [for]="input?.key + '-checking'" class="no-margin-bottom radio-labels-padding">{{ 'CHECKING' | translate }}</label>
          <!-- </div> -->
        </div>
        <div class="account-type-radio-option">
          <!-- <div> -->
            <input
            type="radio"
            [id]="input?.key + '-savings'"
            [name]="input?.key"
            [formControlName]="input?.key"
            value="SAVINGL"
            (change)="OnKeyUp(this)"
          />
          <!-- </div>
          <div> -->
            <label [for]="input?.key + '-savings'" class="no-margin-bottom radio-labels-padding">Savings</label>
          <!-- </div> -->
        </div>
      </div>
      <div *ngIf= "checkForRegularInput(input)" [ngClass]="{'editMailAddressApt w-100-mobile': input?.key === 'changeAddressAPT'}">
        <input
          (blur)= "OnBlur(this)"
          (focus)= "OnFocus(this)"
          (keyup)="OnKeyUp(this, $event)"
          [class]= "input?.additionalClasses"
          [formControlName]= "input?.key"
          [id]= "input?.key"
          [maxLength]="input?.maxLength || maximumLength"
          [name]= "input?.key"
          [ngClass]="{'error': !validInput}"
          [type]= "input?.inputType"
          [min]="input?.min"
          [max]="input?.max"
          [placeholder]="input?.placeholder"
          autocomplete="off"
          #textbox
          mdbInput
        />
        <ng-container *ngIf="input?.hasCallenderCustomIcon">
          <img src="assets/img/images/icon-calendar.svg" style="
          pointer-events: none;
          position: absolute;
          right: 24px;
          top: 8px;
          ">
        </ng-container>
        <mapfre-label [forInput]= "input?.key" [validationCSSClass]="validInput" [ngClass]="{'tested': input?.key === 'changeAddressAPT','bankEdit': input?.key?.includes('enrollInEft_')}">{{ input?.label | translate }}</mapfre-label>
      </div>
    
      <div class="help-block error-block" *ngIf="input?.key !== 'createPassword'">
        <!-- &nbsp; -->
        <ng-container *ngIf= "!isValid && validMessageShow && !message && input?.inputType !== 'password'; else validationError">
          <div class="warning-row"  *ngIf="showWarnIcon">
            <span class="warning-icon"></span>
            <ng-container *ngIf= "form.get(input.key)?.errors?.notMatch; else validationMsg">
              {{input?.matchMessageError | translate }}
            </ng-container>
            <ng-template #validationMsg>{{input?.validationMessageError | translate }}</ng-template>
          </div>

           <div *ngIf="!showWarnIcon">
              {{ input?.validationMessageError | translate }}
           </div>
          <!-- {{ input?.validationMessageError | translate }} -->
        </ng-container>
        <ng-template #validationError>
          <ng-container *ngIf= "!isValid && validMessageShow && input?.inputType !== 'password'">
            {{ input?.validationMessageError | translate }}
          </ng-container>
        </ng-template>
        <ng-container *ngIf= "isValid && showError && errorMessage && (input?.key === 'changeAddress' || input?.key === 'newPayment_mailingAddress' || input?.key === 'confirmation_changeEmail')">
          {{ errorMessage | translate }}
        </ng-container>
        <ng-container *ngIf="!isValid && !form.controls.changePassword?.errors?.required && input?.key === 'changePassword'">
          <img src="./assets/img/images/mfa-icon-warning.png" class="mr-1">{{ input?.validationMessageError | translate }}
        </ng-container>
        <ng-container *ngIf="message?.type === 'error' && input?.key === 'createPassword' ">
          {{ message?.text | translate }}
        </ng-container>
        <ng-container *ngIf="changeAddressError === true && ( input?.addressType === 'mailing' || input?.key === 'newPayment_mailingAddress' ) ">
          {{ 'ENTER_VALID_ADDRESS' | translate }}
        </ng-container>
        <ng-container
          *ngIf="changeAddressError === true && ( input?.addressType !== 'mailing' && input?.key !== 'newPayment_mailingAddress') ">
          <ng-conainer *ngIf="addressErrorForAcmic; else errorForMa">
            <ng-container *ngIf="policyStateCode === 'ID'">
              {{ 'PLEASE_ENTER_VALID_ADDRESS_ID' | translate }}
            </ng-container>
            <ng-container *ngIf="policyStateCode === 'WA'">
              {{ 'PLEASE_ENTER_VALID_ADDRESS_WA' | translate }}
            </ng-container>
          </ng-conainer>
          <ng-template #errorForMa>
            <ng-container *ngIf="policyStateCode === 'MA'">
              {{ 'PLEASE_ENTER_VALID_ADDRESS' | translate }}
            </ng-container>
            <ng-container *ngIf="policyStateCode === 'CA'">
              {{ 'PLEASE_ENTER_VALID_ADDRESS_CA' | translate }}
            </ng-container>
          </ng-template>
        </ng-container>
        <ng-container *ngIf="showInvalidZipcodeMsg === true && ( input?.key === 'changeAddress_zipCode' || input?.key === 'changeAddress_PO_zipCode'
         || input?.key === 'newPayment_zipCode' || input?.key === 'newPayment_PO_zipCode') ">
          {{ 'ENTER_VALID_ZIPCODE' | translate }}
        </ng-container>
        <ng-container *ngIf="showRequiredError && input?.key === 'changePassword' ">
            <img src="./assets/img/images/mfa-icon-warning.svg" class="mr-1">
            {{ 'REQUIRED' | translate }}
        </ng-container>
      </div>
      <div class="password-validation-errors" *ngIf="input?.key === 'createPassword' " [ngClass]="{'mt-1':
            (nameError ||
            firstNameError ||
            lastNameError ||
            middleNameError ||
            showRequiredError ||
            passwordMustNotErrorMsg) && (input?.key === 'createPassword')
        }">
        <ng-container *ngIf="nameError && input?.key === 'createPassword' ">
          {{ 'NAME_AS_PASSWORD_ERROR' | translate }}
        </ng-container>
        <ng-container *ngIf="firstNameError && input?.key === 'createPassword' ">
          {{ 'FIRST_NAME_AS_PASSWORD_ERROR' | translate }}
        </ng-container>
        <ng-container *ngIf="lastNameError && input?.key === 'createPassword' ">
          {{ 'LAST_NAME_AS_PASSWORD_ERROR' | translate }}
        </ng-container>
        <ng-container *ngIf="middleNameError && input?.key === 'createPassword' ">
          {{ 'MIDDLE_NAME_AS_PASSWORD_ERROR' | translate }}
        </ng-container>
        <ng-container *ngIf="showRequiredError && input?.key === 'createPassword' ">
            <img src="./assets/img/images/mfa-icon-warning.svg" class="mr-1">
            {{ 'REQUIRED' | translate }}
        </ng-container>
         <ng-container *ngIf="input?.key === 'createPassword' && passwordMustNotErrorMsg">
           {{passwordMustNotErrorMsg}}
        </ng-container>
      </div>

      <div class="help-block pos-sat info-block" *ngIf="input?.inputType === 'password' && capsLock">
        <mapfre-icon iconClasses="fas fa-exclamation-triangle"></mapfre-icon> <span class="info-block-copy">{{ 'CAPS_LOCK' | translate }}</span>
      </div>
    </div>
  </div>
</div>


 
   


<ng-container *ngIf= "input?.key === 'createPassword' ">
  <div class="password-validation margin-top margin-bottom mb24" [ngClass]="{'margin-bottom mb32':isAcmic}">
    <div class="row">
      <div class="col password-requirement" [ngClass]="{'mt-45':
            (nameError ||
            firstNameError ||
            lastNameError ||
            middleNameError ||
            showRequiredError ||
            passwordMustNotErrorMsg) && (input?.key === 'createPassword') && !isAcmic
        }">
        {{ 'PASSWORD_REQUIREMENTS' | translate }}
      </div>
    </div>
    <div class="row margin-bottom mb8" [ngClass]="{'valid': passwordRules('ruleFour'), 'not-fullfilled': !passwordRules('ruleFour')}">
      <div class="col">  
        <div class="icon">
        <ng-container *ngIf= "isAcmic; else maIconRuleFour">
          <ng-container *ngIf= "passwordRules('ruleFour'); else rulefourpass">
            <img src="assets/img/images/icon-check-circle-active-acmic.svg" class="password-ma" alt="check icon">
          </ng-container>
          <ng-template #rulefourpass>
            <img src="assets/img/images/icon-check-circle-inactive-acmic.svg" class="password-ma" alt="check icon">
          </ng-template>
        </ng-container>
        <ng-template #maIconRuleFour>

           <ng-container *ngIf= "passwordRules('ruleFour'); else rulefourpass">
            
             <img src="assets/img/images/active-check-circle-ma.svg" class="password-ma" alt="check icon">
          
          </ng-container>
          <ng-template #rulefourpass>
            
              <img src="assets/img/images/inactive-check-circle-ma.svg" class="password-ma" alt="check icon">
        
          </ng-template>  
        </ng-template>
          <span class="sr-only sr-only-focusable" *ngIf="!passwordRules('ruleFour')">{{ 'DOES_NOT_PASS' | translate }}</span>
          <span class="sr-only sr-only-focusable" *ngIf="passwordRules('ruleFour')">{{ 'PASSES_THE_RULE' | translate }}</span>
        </div>
        <div class="rule align-middle password-rule">
            {{ 'PASSWORD_RULE_FOUR' | translate }}
          </div>
      </div>
    </div>
    <div class="row margin-bottom mb8" [ngClass]="{'valid': passwordRules('ruleOne'), 'not-fullfilled': !passwordRules('ruleOne')}">
      <div class="col">
        <div class="icon">
          <ng-container *ngIf= "isAcmic; else maIconRuleOne">
            <ng-container *ngIf= "passwordRules('ruleOne'); else ruleonepass">
              <img  src="assets/img/images/icon-check-circle-active-acmic.svg" class="password-ma" alt="check icon">
            </ng-container>
            <ng-template #ruleonepass>
              <img  src="assets/img/images/icon-check-circle-inactive-acmic.svg" class="password-ma" alt="check icon">
            </ng-template>
          </ng-container>
          <ng-template #maIconRuleOne>
            <ng-container *ngIf= "passwordRules('ruleOne'); else ruleonepass">
              
                <img src="assets/img/images/active-check-circle-ma.svg" class="password-ma" alt="check icon">
              
            </ng-container>
            <ng-template #ruleonepass>
              <i class="">
                <img src="assets/img/images/inactive-check-circle-ma.svg" class="password-ma" alt="check icon">
              </i>
            </ng-template>  
          </ng-template>
          <span class="sr-only sr-only-focusable" *ngIf="!passwordRules('ruleOne')">{{ 'DOES_NOT_PASS' | translate }}</span>
          <span class="sr-only sr-only-focusable" *ngIf="passwordRules('ruleOne')">{{ 'PASSES_THE_RULE' | translate }}</span>
        </div>
        <div class="rule align-middle password-rule">
          {{ 'PASSWORD_RULE_ONE' | translate }}
        </div>
      </div>
    </div>
    <div class="row margin-bottom mb8" [ngClass]="{'valid': passwordRules('ruleSix'), 'not-fullfilled': !passwordRules('ruleSix')}">
      <div class="col">
        <div class="icon">
          <ng-container *ngIf= "isAcmic; else maIconRuleSix">
            <ng-container *ngIf= "passwordRules('ruleSix'); else rulesixpass">
              <img  src="assets/img/images/icon-check-circle-active-acmic.svg" class="password-ma" alt="check icon">
            </ng-container>
            <ng-template #rulesixpass>
              <img  src="assets/img/images/icon-check-circle-inactive-acmic.svg" class="password-ma" alt="check icon">
            </ng-template>
          </ng-container>
          <ng-template #maIconRuleSix>
            <ng-container *ngIf= "passwordRules('ruleSix'); else rulesixpass">
              
                <img src="assets/img/images/active-check-circle-ma.svg" class="password-ma" alt="check icon">
              
            </ng-container>
            <ng-template #rulesixpass>
              
                <img src="assets/img/images/inactive-check-circle-ma.svg" class="password-ma" alt="check icon">
              
            </ng-template> 
          </ng-template>
          <span class="sr-only sr-only-focusable" *ngIf="!passwordRules('ruleSix')">{{ 'DOES_NOT_PASS' | translate }}</span>
          <span class="sr-only sr-only-focusable" *ngIf="passwordRules('ruleSix')">{{ 'PASSES_THE_RULE' | translate }}</span>
        </div>
        <div class="rule align-middle password-rule">
          {{ 'PASSWORD_RULE_SIX' | translate }}
        </div>
      </div>
    </div>
    <div class="row margin-bottom mb8" [ngClass]="{'valid': isPswdThirdRuleValid, 'not-fullfilled': !isPswdThirdRuleValid}">
      <div class="col">
        <div class="icon">
          
          <ng-container *ngIf= "isAcmic; else maIconRuleThree">
            <ng-container *ngIf= "isPswdThirdRuleValid; else rulethreepass">
              <img  src="assets/img/images/icon-check-circle-active-acmic.svg" class="password-ma" alt="check icon">
            </ng-container>
            <ng-template #rulethreepass>
              <img  src="assets/img/images/icon-check-circle-inactive-acmic.svg" class="password-ma" alt="check icon">
            </ng-template>
          </ng-container>
          <ng-template #maIconRuleThree>
            <ng-container *ngIf= "isPswdThirdRuleValid; else rulethreepass">
            
                <img src="assets/img/images/active-check-circle-ma.svg" class="password-ma" alt="check icon">
             
            </ng-container>
            <ng-template #rulethreepass>
              
                <img src="assets/img/images/inactive-check-circle-ma.svg" class="password-ma" alt="check icon">
              
            </ng-template> 
          </ng-template>
          <span class="sr-only sr-only-focusable" *ngIf="!isPswdThirdRuleValid">{{ 'DOES_NOT_PASS' | translate }}</span>
          <span class="sr-only sr-only-focusable" *ngIf="isPswdThirdRuleValid">{{ 'PASSES_THE_RULE' | translate }}</span>
        </div>
        <div class="rule align-middle password-rule">
            {{ 'PASSWORD_RULE_THREE' | translate }}
          </div>
      </div>
    </div> 
    <div class="row margin-bottom mb8" [ngClass]="{'valid': passwordRules('ruleTwo'), 'not-fullfilled': !passwordRules('ruleTwo')}">
      <div class="col">  
        <div class="icon">
          <ng-container *ngIf= "isAcmic; else maIconRuleTwo">
            <ng-container *ngIf= "passwordRules('ruleTwo'); else ruletwopass">
              <img  src="assets/img/images/icon-check-circle-active-acmic.svg" class="password-ma" alt="check icon">
            </ng-container>
            <ng-template #ruletwopass>
              <img  src="assets/img/images/icon-check-circle-inactive-acmic.svg" class="password-ma" alt="check icon">
            </ng-template>
          </ng-container>
          <ng-template #maIconRuleTwo>
            <ng-container *ngIf= "passwordRules('ruleTwo'); else ruletwopass">
              
                <img src="assets/img/images/active-check-circle-ma.svg" class="password-ma" alt="check icon">
             
            </ng-container>
            <ng-template #ruletwopass>
              
                <img src="assets/img/images/inactive-check-circle-ma.svg" class="password-ma" alt="check icon">
              
            </ng-template> 
          </ng-template>
          <span class="sr-only sr-only-focusable" *ngIf="!passwordRules('ruleTwo')">{{ 'DOES_NOT_PASS' | translate }}</span>
          <span class="sr-only sr-only-focusable" *ngIf="passwordRules('ruleTwo')">{{ 'PASSES_THE_RULE' | translate }}</span>
        </div>
        <div class="rule align-middle password-rule">
            {{ 'PASSWORD_RULE_TWO' | translate }}
          </div>
      </div>
    </div>
    <ng-container *ngIf="isAcmic; else maContainer">
       <div class="must-not-rules">
      <div>
      <p class="must-not-rules-heading">Must not</p>
    </div> 
    <div class="must-not-rules-container">
        <img src="assets/img/images/acmic-icon-delete-circle.png"/>
      <div>
        <p class="must-not-rules-text">Contain your first or last name</p>
      </div>
    </div>
    <div class="must-not-rules-container">
        <img src="assets/img/images/acmic-icon-delete-circle.png"/>
      <div>
        <p class="must-not-rules-text">Match any of your last three passwords</p>
      </div>
    </div>
    <div class="must-not-rules-container">
          <img src="assets/img/images/acmic-icon-delete-circle.png"/>
      <div>
        <p class="must-not-rules-text">Use common or easily guessable passwords</p>
      </div>
    </div>
    </div>
    </ng-container>
    <ng-template #maContainer>
      <div class="must-not-rules">
      <div>
      <p class="must-not-rules-heading">Must not</p>
    </div> 
    <div class="must-not-rules-container">
        <img src="assets/img/images/ma-icon-delete-circle.png"/>
      <div>
        <p class="must-not-rules-text">Contain your first or last name</p>
      </div>
    </div>
    <div class="must-not-rules-container">
        <img src="assets/img/images/ma-icon-delete-circle.png"/>
      <div>
        <p class="must-not-rules-text">Match any of your last three passwords</p>
      </div>
    </div>
    <div class="must-not-rules-container">
          <img src="assets/img/images/ma-icon-delete-circle.png"/>
      <div>
        <p class="must-not-rules-text">Use common or easily guessable passwords</p>
      </div>
    </div>
    </div>
    </ng-template>
  </div>
</ng-container>